export const getImagePath = url => {
  const path = process.env.REACT_APP_API_ROOT_URL + url
  return path
}

export const getUserImagePath = (rowID, fileName) => {
  const path =
    process.env.REACT_APP_API_ROOT_URL +
    `/APIImageHandler.ashx?Path=_files/User/_${rowID}`
  return path
}

export const getDocumentFilePath = (rowID, fileName) => {
  const extension = fileName.split(".").pop().toLowerCase()
  const path =
    process.env.REACT_APP_API_ROOT_URL +
    `/_files/Document/_${rowID}.${extension}`
  return path
}
